import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { icons } from './assets/icons';
import { Provider } from 'react-redux';
import { store } from './store';
import { setAuth } from './views/slice/role';
import { getStoredUser, getStoredToken } from './utils/auth';

React.icons = icons;

const user = getStoredUser();
const token = getStoredToken();
if (user && token) {
  store.dispatch(setAuth({ user, token }));
}
const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
